import { createQuestionValueMap, getUpdatedItems, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, updateMapWithFields } from "../../../../common/summary-common/confirmationData";

export const defaultInsuranceInformation: Map<string, ConfirmationData> = new Map([
    ["e4ad8789-022b-45eb-b19f-265c1988f9fe", { fontWeight: "bold" }],
    ["48988f29-3079-4fef-b43f-fa5ac53700ef", { label: "Sí/No", showBorder: true }],
]);

export const defaultHealthInsurance: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Seguro médico", fontWeight: "bold" }],
    ["b6baa155-8909-4f1e-a8eb-8b177373748f", { showBorder: true }],
]);

const individualInsured: Map<string, ConfirmationData> = new Map([
    ["97b63d24-977a-4ed1-a683-db4f1efcef4b", { fontWeight: "bold" }],
    ["b404adb7-9675-4ef2-91a2-e8029f127e9f", { label: "Sí/No", showBorder: true }],
])

const existingLifeInsurance: Map<string, ConfirmationData> = new Map([
    ["699c8838-7c6c-4a11-bd6b-28e7ce709853", { fontWeight: "bold" }],
    ["a4b17cd9-d538-4e7d-82a9-61c280a835da", { label: "Sí/No", showBorder: true }],
])

export const defaultLifeInsurance: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Seguro de vida", fontWeight: "bold" }],
    ["3b5d755a-0de8-4cdc-b58f-5fc789f527a0", {}],
    ["3cb46b20-c80d-48b4-8e7d-5c2f374c4b59", {}],
    ["c43aa3e1-7be3-47e0-9fe2-ef61e6e7dedd", { showBorder: true }],
]);

const primeRecharger: Map<string, ConfirmationData> = new Map([
    ["d05c70d9-8adc-4fd5-b1bb-a0637e1827ff", { fontWeight: "bold" }],
    ["29e42fe5-41b3-493b-bff4-97b1fd018aa6", { label: "Sí/No", showBorder: true }],
])

const relation1: Map<string, ConfirmationData> = new Map([
    ["468c9623-cd96-477e-a64d-67727d21ea3a", { fontWeight: "bold" }],
    ["268bfab1-caf4-48de-b428-9527d7d4de4c|2657dd0e-9eaf-4455-a8f3-31f9367d8bb6", { showBorder: true }],
])

const relation2: Map<string, ConfirmationData> = new Map([
    ["7d6b9cb8-9e29-47ae-b872-103dd73d4735", { fontWeight: "bold" }],
    ["69a7dc44-67ea-4e9f-8ea1-4e7b7e374d49|2657dd0e-9eaf-4455-a8f3-31f9367d8bb6", {}]
])

export const updateInsuranceInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    const answersMap = createQuestionValueMap(page);
    const medicalCoverageValue = answersMap.get("48988f29-3079-4fef-b43f-fa5ac53700ef")?.value
    const haveMedicalCoverage = (medicalCoverageValue !== "No" && medicalCoverageValue !== "")
    const updatedHealthInsuranceItems = getUpdatedItems(page, "cbf46861-028b-4cce-bf88-08ebff7dfb42", "43017ff1-342d-49d0-8ffc-ea7a75565669", defaultHealthInsurance, false)
    if (haveMedicalCoverage) {
        cd = new Map([
            ...cd,
            ...updatedHealthInsuranceItems,
        ]);
    }

    cd = new Map([
        ...cd,
        ...individualInsured,
    ]);

    if (answersMap.get("b404adb7-9675-4ef2-91a2-e8029f127e9f")?.value === "Sí") {

        cd = new Map([
            ...cd,
            ...existingLifeInsurance,
        ]);
    }

    const lifeInsuranceValue = answersMap.get("a4b17cd9-d538-4e7d-82a9-61c280a835da")?.value
    const haveLifeInsurance = (lifeInsuranceValue !== "No" && lifeInsuranceValue !== "")
    const updatedLifeInsuranceItems = getUpdatedItems(page, "fd68450e-bfa9-47c1-ba99-4035c7be8fc4", "9b38f6c5-6b2b-4edf-8a1e-da6ca2d4db06", defaultLifeInsurance, false)
    if (haveLifeInsurance) {
        cd = new Map([
            ...cd,
            ...updatedLifeInsuranceItems,
        ]);
    }
    cd = new Map([
        ...cd,
        ...primeRecharger,
    ]);
    const primeRechargerValue = answersMap.get("a4b17cd9-d538-4e7d-82a9-61c280a835da")?.value
    const haveprimeRecharger = (primeRechargerValue !== "No" && primeRechargerValue !== "")


    if (haveprimeRecharger) {
        cd = new Map([
            ...cd,
            ...relation1,
            ...relation2,
        ]);
    }

    return updateMapWithFields(mapToTupleArray(answersMap),
        new Map([
            ...cd,
        ])
    );
}
